import type {
  BlogPost,
  BlogQueryParams,
  BlogResponse,
  CreateBlogPostDto,
  UpdateBlogPostDto,
} from '@/types/blog';
import { BaseService } from '../core/base.service';

export class BlogService extends BaseService<BlogPost, CreateBlogPostDto, UpdateBlogPostDto> {
  constructor() {
    super('/blog');
  }

  protected getEntityName(): string {
    return 'Blog post';
  }

  static async getBlogPosts(params: BlogQueryParams = {}): Promise<BlogResponse> {
    const service = new BlogService();
    return service.getRequest<BlogResponse>('/blog/manage', params);
  }

  static async getBlogPostById(id: string): Promise<BlogPost> {
    const service = new BlogService();
    return service.getRequest<BlogPost>(`/blog/manage/${id}`);
  }

  static async createBlogPost(data: CreateBlogPostDto): Promise<BlogPost> {
    const service = new BlogService();
    return service.create(data);
  }

  static async updateBlogPost(id: string, data: UpdateBlogPostDto): Promise<BlogPost> {
    const service = new BlogService();
    return service.update(id, data);
  }

  static async deleteBlogPost(id: string): Promise<{ message: string }> {
    const service = new BlogService();
    return service.delete(id);
  }

  static async bulkDeleteBlogPosts(ids: string[]): Promise<{ deleted_count: number; failed_ids: string[] }> {
    const service = new BlogService();
    const response = await service.bulkDelete(ids);
    return {
      deleted_count: response.successCount ?? ids.length,
      failed_ids: response.errors?.map((item) => item.id) ?? [],
    };
  }

  static async getCategories(): Promise<string[]> {
    const service = new BlogService();
    return service.getRequest<string[]>('/blog/categories');
  }
}

export default BlogService;
